export default __webpack_public_path__ + "static/telematics-af4441e45c65d9f6c534f377f4703d68.jpg";